import usePageContext from '@rover/react-lib/src/context/usePageContext';
import { selectors as hrefLangsSelectors } from '@rover/react-lib/src/redux/ducks/hrefLangs.duck';
import {
  ApiFrontendHrefLangsRetrieve200ResultsItem,
  useApiFrontendHrefLangsRetrieve,
} from '@rover/rsdk/src/apiClient/latest';
import getPath from '@rover/shared/js/utils/getPath';

import useDucks from './useDucks';

export type HrefLangsData = {
  hrefLangs: ApiFrontendHrefLangsRetrieve200ResultsItem[] | undefined;
};

const selector = (state): HrefLangsData => ({
  hrefLangs: hrefLangsSelectors.getHrefLangs(state),
});

const useHrefLangsShim = (): HrefLangsData => {
  const path = getPath();
  const { isReactQueryRoute } = usePageContext();
  const { data } = useApiFrontendHrefLangsRetrieve(
    { path },
    { query: { enabled: isReactQueryRoute } }
  );
  const { data: selectedData } = useDucks({ selector });

  const hrefLangs = isReactQueryRoute ? data?.results : selectedData.hrefLangs;

  return { hrefLangs };
};

export default useHrefLangsShim;
